import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Row, Col } from 'antd';
import { RootState } from '@/redux/store';
import './index.scss';
import { getPermissionById, isNullObject } from '@/utils';
import {
  PermissionTab,
  SingleTabType,
  SingleViewRightTabConfig,
} from '@/utils/constant';
import { clstagStr } from '@/utils/util';
const Tab = ({
  tabChange,
  hasBubble,
  rightTab,
}: {
  tabChange: Function;
  hasBubble?: boolean;
  rightTab?: string;
}) => {
  const login = useSelector((state: RootState) => state.login);
  const { resourceList } = login;
  const [tabArr, setTabArr] = useState<any>([]);
  const [tempActive, setTempActive] = useState<any>();
  useEffect(() => {
    if (!isNullObject(resourceList)) {
      const driveEnableTab = getPermissionById(PermissionTab.SPV_DRIVE_ENABLE);
      const errorInfoTab = getPermissionById(PermissionTab.SPV_ERROR_INFO);
      const operateLogTab = getPermissionById(PermissionTab.SPV_OPERATE_LOG);
      const accidentManageTab = getPermissionById(
        PermissionTab.SPV_ACCIDENT_INVESTIGATION,
      );
      const tempArr = [
        driveEnableTab
          ? SingleViewRightTabConfig[SingleTabType.DRIVABLE]
          : false,
        accidentManageTab
          ? SingleViewRightTabConfig[SingleTabType.ACCIDENT]
          : false,
        errorInfoTab
          ? SingleViewRightTabConfig[SingleTabType.EXCEPTION]
          : false,
        operateLogTab
          ? SingleViewRightTabConfig[SingleTabType.OPERATION]
          : false,
      ].filter(Boolean);
      tabClick(
        rightTab
          ? SingleViewRightTabConfig[rightTab as SingleTabType]
          : tempArr[0],
      );
      setTabArr(tempArr);
    }
  }, [resourceList]);

  const tabClick = (tab: any) => {
    setTempActive(tab);
    tabChange(tab);
  };
  return (
    <div className='tab-con'>
      <Row className='fbox vbox cbox'>
        {tempActive &&
          tabArr.map((tab: any, index: number) => {
            return (
              <Col
                className={`fbox vbox cbox  ${
                  tempActive.index === tab.index ? 'active-col' : ''
                }`}
                span={24 / tabArr.length}
                key={'tab_' + index}
                clstag={clstagStr(tab.clstag)}
                onClick={() => {
                  tabClick(tab);
                }}
              >
                <span
                  className={`tab ${
                    tempActive.index === tab.index ? 'active-tab' : ''
                  }`}
                >
                  {tab.name}
                  {hasBubble && tab.index === 1 ? (
                    <span className='red-bubble'></span>
                  ) : (
                    <></>
                  )}
                </span>
              </Col>
            );
          })}
      </Row>
    </div>
  );
};

export default React.memo(Tab);
